import { render, staticRenderFns } from "./Tekshiruvchi.vue?vue&type=template&id=026a1fbe&scoped=true"
import script from "./Tekshiruvchi.vue?vue&type=script&lang=js"
export * from "./Tekshiruvchi.vue?vue&type=script&lang=js"
import style0 from "./Tekshiruvchi.vue?vue&type=style&index=0&id=026a1fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026a1fbe",
  null
  
)

export default component.exports